// extracted by mini-css-extract-plugin
module.exports = {"Content":"MemberCert_Content__1t-ll","CertContainer":"MemberCert_CertContainer__HOEbQ","UserProfileContainer":"MemberCert_UserProfileContainer__4Iw1Q"};